import './google-review.scss';
import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { googleReview } from 'store/CommonModuleState';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';

const GoogleReview: React.FC = () => {
  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  // Redux State
  const { googleReviewData } = useSelector((state: RootState) => state.commonModuleStore);

  useEffect(() => {
    dispatch(googleReview({ place_id: 'ChIJKevKMWfxLogRQCJLiQ4EfWQ' }));
  }, [dispatch]);

  const gallerySliderReview = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className='carousel-container'>
      <Slider {...gallerySliderReview}>
        {googleReviewData?.map((item, index) => (
          <div key={`review_${index}`} className='carousel-item'>
            <img src={item?.profile_photo_url} alt={item?.author_name} />
            <p>{item?.text}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default GoogleReview;
